import { View } from 'backbone';
import { Model } from 'backbone';
import listService from 'ListService.js';
import selectFieldModalView from 'common-views/SelectFieldModalView.js';
import _template from 'behaviors/properties/main/select-behavior.ejs';
import _ from 'lodash';

class MainSelectBehaviorView extends View {

    initialize( opts ) {
        this.options = opts || {};
        this.template = _template;
        this.tagName = 'div';
        this.id = opts.el;
        this.mode = 'form';
        this.viewTitle= 'Run Behavior Settings';

        this.events = {
            "click #selectBehavior"     : "showSelectModal"
        };

        if (this.model.get('scriptId')) {
            // lookup behavior name
            const behavior = listService.getBehaviorInstance( listService.cleanId( this.model.get('scriptId') ));
            if (behavior) {
                let bName = behavior.get('text');
                this.model.set('script', bName, {silent: true});
                if (this.model.get('autosummary')) {
                    this.model.set('widgetText', bName, {silent: true});
                }
            }
        }

        this.model.set('sectionTitle', this.viewTitle, {silent: true});

        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    showSelectModal(ev) {
        ev.preventDefault();
        const factoryKey= 'modal';

        var sfModel = new Model();
        sfModel.set("dataSelectedItemId", this.model.get("scriptId"), {silent:true});
        sfModel.set("factoryKey", this.model.get('factoryKey'), {silent:true});

        var sfModal = new selectFieldModalView({model: sfModel, mode: 'behaviors'});
        sfModal.render().then((selectedField)=>{
            // PF-1799
            this.model.set('scriptId', selectedField.id, {silent:true});
            this.model.set('script', selectedField.name, {silent:true});
            if (this.model.get('autosummary')) {
                this.model.set('widgetText', selectedField.name);
            }
        }).catch(err => console.log(err));
    }

    updateWidgetText(){
        if (this.model.get('autosummary')) {
            this.model.set('widgetText', this.model.get('script'));
        }
    }

    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }
        this.updateWidgetText();
        this.delegateEvents();
        return this;
    }

}

export default MainSelectBehaviorView;
